var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-blow"},[_c('img',{staticClass:"origin-img",attrs:{"src":"https://ossuat.plantmate.com/commonAttachment/1614059248398/01.jpg","alt":""}}),_c('div',{staticClass:"b-blow"},[_c('img',{staticClass:"blow-img",attrs:{"src":"https://ossuat.plantmate.com/commonAttachment/1614059248398/01.jpg","alt":""}})])])
}]

export { render, staticRenderFns }